import React, { useEffect } from "react";
import "./../Usuarios/usuarios.css";

import { SubSections } from "../../data/navItem";

import ConfiguracionesMain from "./ConfiguracionesMain";
import ProductosPaquetesCatalogo from "./ProductosPaquetesCatalogo";
import BonificacionesMain from "./BonificacionesMain";
import Comisiones from "./Comisiones";

export default function Configuraciones({ subSectionId }) {
  const fetchData = async () => {};

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {subSectionId === SubSections.Principal && <ConfiguracionesMain />}
      {subSectionId === SubSections.Bonificaciones && <BonificacionesMain />}
      {subSectionId === SubSections.Roles && <div />}
      {subSectionId === SubSections.Paquetes && <ProductosPaquetesCatalogo />}
      {subSectionId === SubSections.Comision && <Comisiones />}
    </>
  );
}
